import React from 'react';

import classes from './UserDrawer.module.css';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Aux from '../../../hoc/Auxx/Auxx';
import {Button} from "@material-ui/core";
import UserSidebar from "../../../containers/UserSidebar/UserSidebar";

const userDrawer = (props ) => {
    let attachedClasses = [classes.UserDrawer, classes.Close];
    if (props.open) {
        attachedClasses = [classes.UserDrawer, classes.Open];
    }
    return (
        <Aux>
            <Backdrop show={props.open} clicked={props.closed}/>
            <div className={attachedClasses.join(' ')}>
                <UserSidebar sideDrawerOpen={props.open}/>
                <Button className={classes.CancelButton} onClick={props.closed}>Close</Button>
            </div>
        </Aux>
    );
};

export default userDrawer;